// extracted by mini-css-extract-plugin
export default {"rules-table":"rulesTable_rules-table__xaRw7","filter-row":"rulesTable_filter-row__1rpVu"};